import { useEffect } from 'react';

// eslint-disable-next-line import/prefer-default-export
const useCaptureMarketingData = () => {
  useEffect(() => {
    const paramsToCapture = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

    function getParam(param: string) {
      const url = new URL(window.location.href);
      return url.searchParams.get(param);
    }

    function captureData() {
      paramsToCapture.forEach((key) => {
        const val = getParam(key);
        if (val && !localStorage.getItem(key)) {
          localStorage.setItem(key, val);
        }
      });

      if (
        document.referrer
        && !document.referrer.includes(window.location.hostname)
        && !localStorage.getItem('referrer')
      ) {
        localStorage.setItem('referrer', document.referrer);
      }

      if (!localStorage.getItem('ga_client_id')) {
        const match = document.cookie.match(/_ga=GA\d+\.\d+\.(\d+\.\d+)/);
        if (match) {
          localStorage.setItem('ga_client_id', match[1]);
        }
      }
    }

    captureData();

    let lastUrl = window.location.href;
    const observer = new MutationObserver(() => {
      const currentUrl = window.location.href;
      if (currentUrl !== lastUrl) {
        lastUrl = currentUrl;
        captureData();
      }
    });

    observer.observe(document, { subtree: true, childList: true });

    return () => observer.disconnect();
  }, []);
};

export default useCaptureMarketingData;
